import React from 'react'
import FooterBackground from '../../images/footer-background.png'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import Wrapper from '../../components/layout/Wrapper'

const Footer = styled.div`
  background: url(${FooterBackground});
  padding: 40px;
  display: grid;
  color: #fff;

  ${breakpoint('desktop')`
    padding: 40px;
  `}
`

const Copyright = styled(Wrapper)`
  font-size: 0.6em;
  text-align: center;
  max-width: 150%;
`

export default props => (
  <Footer>
    <Copyright>
      TODOS LOS DERECHOS RESERVADOS. 2018 © BAC INTERNATIONAL BANK
    </Copyright>
  </Footer>
)
